<fury-list>
    <div class="table">
      <table mat-table [dataSource]="dataSource">
  
    
       <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Created on</th>
        <td mat-cell *matCellDef="let element">
          {{ commonService.convertDate(element?.createdAt) | date : "MMM-dd-YYYY h:mm a" }}
        </td>
      </ng-container>
  
           <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef>Updated on</th>
            <td mat-cell *matCellDef="let element">{{ commonService.convertDate(element?.updatedAt) | date : "MMM-dd-YYYY h:mm a" }}</td>
          </ng-container>

          <ng-container matColumnDef="changedBy">
            <th mat-header-cell *matHeaderCellDef>Changed By</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.agentId?.firstName }}  {{ element?.agentId?.lastName }}
      
            </td>
          </ng-container>
  
     
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.status }}
    
          </td>
        </ng-container>
  
        <ng-container matColumnDef="note">
          <th mat-header-cell *matHeaderCellDef>Note</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.note }}
          </td>
        </ng-container>

  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        *ngIf="!dataSource?.length"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
    </div>
  </fury-list>
  